export default __webpack_public_path__ + "static/media/users-color.8ee780c1.svg";